import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { ColorPicker, Text } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context.js'
import CodeWidget from '@/configuration/pages/ConfigurationPage/ExtrasConfiguration/CodeWidget/CodeWidget.jsx'

import useCreateWidgetScript from './hooks/useCreateWidgetScript/useCreateWidgetScript.js'
import SortingSelector from './SortingSelector/SortingSelector.jsx'
import * as Styles from './styles.js'

const ShippingWidgetConfiguration = ({
  backgroundColor,
  textColor,
  actionsColor,
  freeShippingBannerBackgroundColor,
  freeShippingBannerTextColor,
  sortingType,
  onChangeBackgroundColor,
  onChangeTextColor,
  onChangeActionsColor,
  onChangeFreeShippingBackgroundColor,
  onChangeFreeShippingTextColor,
  onChangeSortingType,
  scriptInfo,
}) => {
  const { t } = useTranslation()
  const { info } = useContext(AppContext)

  useCreateWidgetScript({
    backgroundColor,
    textColor,
    sortingType,
    actionsColor,
    freeShippingBannerBackgroundColor,
    freeShippingBannerTextColor,
    store: info.selectedStore,
  })

  return (
    <Styles.Container>
      <Text type="titleM">{t('Widget envíos')}</Text>
      <Text type="bodyMRegular">
        {t(
          'Añade nuestro widget de envíos a las páginas de producto de tu tienda para mostrar a tus clientes los métodos de envío disponibles y el tiempo estimado de entrega para su región.'
        )}
      </Text>

      <Styles.ColorsContainer>
        <Text type="titleS">{t('Colores del widget')}</Text>
        <Styles.ColorsPickerContainer>
          <ColorPicker
            onChange={color => onChangeBackgroundColor(color)}
            label={t('Color del fondo')}
            type="colorPreview"
            defaultColor={backgroundColor}
          />
          <ColorPicker
            onChange={color => onChangeTextColor(color)}
            label={t('Color del texto')}
            type="colorPreview"
            defaultColor={textColor}
          />
          <ColorPicker
            onChange={color => onChangeActionsColor(color)}
            label={t('Color de las acciones')}
            type="colorPreview"
            defaultColor={actionsColor}
          />
          <ColorPicker
            onChange={color => onChangeFreeShippingBackgroundColor(color)}
            label={t('Color de fondo: "Consigue envío gratis"')}
            type="colorPreview"
            defaultColor={freeShippingBannerBackgroundColor}
          />
          <ColorPicker
            onChange={color => onChangeFreeShippingTextColor(color)}
            label={t('Color de texto: "Consigue envío gratis"')}
            type="colorPreview"
            defaultColor={freeShippingBannerTextColor}
          />
        </Styles.ColorsPickerContainer>
      </Styles.ColorsContainer>
      <Styles.DisplayContainer>
        <Text type="titleS">{t('Opciones de visualización')}</Text>
        <SortingSelector value={sortingType} onChange={onChangeSortingType} />
      </Styles.DisplayContainer>
      <Styles.PreviewContainer>
        <Text type="titleS">{t('Previsualización')}</Text>
        <Styles.Preview>
          <div id="reveni-load-widget"></div>
        </Styles.Preview>
      </Styles.PreviewContainer>
      <CodeWidget store={info.selectedStore} scriptInfo={scriptInfo} />
    </Styles.Container>
  )
}

export default ShippingWidgetConfiguration
